/* eslint-disable @typescript-eslint/no-explicit-any */
import { TFunction } from 'i18next';

import type { ApiError } from 'services/api';

import { AddToastParams } from 'providers/Toast';

import { AppQuery } from './invalidateQueries';

type MutationMessageResult = Omit<AddToastParams, 'type'> | string;

export type MutationMessage = MutationMessageResult | ((t: TFunction) => MutationMessageResult);

export type MutationMessageConfig = {
  success?: MutationMessage;
  error?: MutationMessage;

  suppressSuccess?: boolean;
  suppressError?: boolean;
};

export type ValidateMutationFunctionReturn = {
  ok: boolean;
  message?: AddToastParams | null | string;
  errors?: Record<string, string>;
};

export type MutationErrorParser = (err: ApiError) => MutationMessage;

export interface BaseEntityMutation {
  action: (params: any) => Promise<any>;

  validate?: (payload: any) => ValidateMutationFunctionReturn;

  messages?: MutationMessageConfig;

  parseError?: MutationErrorParser;

  invalidateOnSuccess?: AppQuery[];
}

export type Mutations<EntityMutations extends Record<string, BaseEntityMutation>> = {
  [key in keyof EntityMutations]: Omit<BaseEntityMutation, 'action' | 'validate'> & {
    action: EntityMutations[key]['action'];
  } & (EntityMutations[key]['validate'] extends undefined
      ? object
      : {
          validate: EntityMutations[key]['validate'];
        });
};

// get intellisense without needing to define each and every mutation key across all entities
export function getMutations<EntityMutations extends Record<string, BaseEntityMutation>>(
  mutations: EntityMutations,
): Mutations<EntityMutations> {
  return mutations as Mutations<EntityMutations>;
}
